<div class="cvds-cooling-system">

  <div *ngIf="fieldsModel.length">
    <cv-cvds-field-table
      [items]="fieldsModel"
    ></cv-cvds-field-table>
  </div>

  <div *ngFor="let item of fieldsSections">
    <cv-cvds-field-array
      [items]="item.items"
      [fields]="item.fields"
      [title]="item.title"
    ></cv-cvds-field-array>
  </div>

  <div *ngIf="cooling.cv_photos?.length">
    <div class="card cv-card__main shadow-sm">
      <div class="card-header">Cooling Photos</div>
      <div class="card-body">
        <cv-cvds-photos 
          [photos]="cooling.cv_photos">
        </cv-cvds-photos>
      </div>
    </div>
  </div>

</div>